import React from "react";
import { Platform, StyleSheet, Text, View } from "react-native";
import { useCustomTheme } from "../hooks/useCustomTheme";
import { ThemedTextWithBold } from "./ThemedTextWithBold";
const listItemRegex = /^\s*-\s+(.*)$/;
const webListStyle = {
    marginTop: 8,
    marginBottom: 8,
    paddingInlineStart: 24,
};
const webListItemStyle = {
    marginTop: 4,
};
const webFirstListItemStyle = {
    marginTop: 0,
};
const parseContentBlocks = (text) => text
    .split(/\n{2,}/)
    .map((block) => block.trim())
    .filter(Boolean)
    .map((block, index) => {
    const lines = block
        .split("\n")
        .map((line) => line.trim())
        .filter(Boolean);
    const listMatches = lines.map((line) => line.match(listItemRegex));
    if (lines.length > 0 && listMatches.every((match) => Boolean(match))) {
        return {
            type: "list",
            items: listMatches.map((match) => match?.[1] ?? ""),
            key: index,
        };
    }
    return {
        type: "paragraph",
        text: block,
        key: index,
    };
});
const hasListBlock = (blocks) => blocks.some((block) => block.type === "list");
export const ThemedRichText = ({ style, textContent, fontDefault, fontBold, }) => {
    const { fonts } = useCustomTheme();
    const parsedFontDefault = fontDefault ?? fonts.regular;
    const parsedBlocks = React.useMemo(() => parseContentBlocks(textContent), [textContent]);
    if (!hasListBlock(parsedBlocks)) {
        return (<ThemedTextWithBold style={style} textContent={textContent} fontDefault={fontDefault} fontBold={fontBold}/>);
    }
    return (<View>
      {parsedBlocks.map((block, blockIndex) => {
            const blockStyle = blockIndex > 0 ? styles.blockSpacing : undefined;
            if (block.type === "paragraph") {
                return (<View key={`paragraph-${block.key}`} style={blockStyle}>
              <ThemedTextWithBold style={style} textContent={block.text} fontDefault={fontDefault} fontBold={fontBold}/>
            </View>);
            }
            if (Platform.OS === "web") {
                return (<View key={`list-${block.key}`} style={blockStyle}>
              <ul style={webListStyle}>
                {block.items.map((item, itemIndex) => (<li key={`list-${block.key}-item-${itemIndex}`} style={itemIndex === 0 ? webFirstListItemStyle : webListItemStyle}>
                    <ThemedTextWithBold style={style} textContent={item} fontDefault={fontDefault} fontBold={fontBold}/>
                  </li>))}
              </ul>
            </View>);
            }
            return (<View key={`list-${block.key}`} role="list" style={[blockStyle, styles.nativeList]}>
            {block.items.map((item, itemIndex) => (<View key={`list-${block.key}-item-${itemIndex}`} role="listitem" style={[
                        styles.nativeListItem,
                        itemIndex === 0 ? undefined : styles.nativeListItemSpacing,
                    ]}>
                <Text style={[style, parsedFontDefault, styles.nativeListMarker]}>
                  {"\u2022 "}
                </Text>
                <View style={styles.nativeListItemContent}>
                  <ThemedTextWithBold style={style} textContent={item} fontDefault={fontDefault} fontBold={fontBold}/>
                </View>
              </View>))}
          </View>);
        })}
    </View>);
};
const styles = StyleSheet.create({
    blockSpacing: {
        marginTop: 12,
    },
    nativeList: {
        marginTop: 4,
        paddingLeft: 16,
    },
    nativeListItem: {
        flexDirection: "row",
        alignItems: "flex-start",
    },
    nativeListItemSpacing: {
        marginTop: 4,
    },
    nativeListMarker: {
        lineHeight: 24,
    },
    nativeListItemContent: {
        flexShrink: 1,
    },
});
//# sourceMappingURL=ThemedRichText.js.map